<template lang="pug">
  div.flicking-wrapper
    flicking(
      ref="flicking"
      v-bind="attrs"
    )
      slot(
        :attrs=`{
          class: 'flicking-panel'
        }`
      )
</template>

<script lang="js">
import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';

const CONTEXT_NAME = 'flicking';

export default {
  props: {
    dissapear: {
      type: Boolean,
      value: false,
    },
    disappearPosition: {
      type: String,
      default: 'right',
    },
    options: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  computed: {
    classes() {
      const { disappear, disappearPosition } = this;
      return {
        [`${CONTEXT_NAME}`]: true,
        [`${CONTEXT_NAME}-disappear`]: disappear,
        [`${CONTEXT_NAME}-disappear-position-${disappearPosition}`]: disappear,
      };
    },
    attrs() {
      const { options, classes } = this;
      return {
        options: {
          ...options,
          autoInit: false,
        },
        class: classes,
      };
    },
  },
  methods: {
    async init() {
      await this.$refs.flicking.init();
    },
  },
};
</script>

<style lang="scss" scoped>
  .flicking {
    :deep(.v-img) {
      pointer-events: none;
    }

    :deep(.flicking-panel) {
      &:not(:last-of-type) {
        margin-right: 8px;
      }
    }

    &-wrapper {
      position: relative;
    }

    &-disappear {
      &:after {
        content: "";
        z-index: 1;
        position: absolute;
        top: 0;
        width: 25%;
        height: 100%;
        background: linear-gradient(-90deg, rgba(255,255,255, 1), rgba(255,255,255, 0));
      }

      &-position-right {
        &:after {
          right: 0,
        }
      }
    }
  }
</style>
